// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2616":"css/admin-app.6874","5052":"css/app.6874"}[chunkId] + ".css";
};